<template>
  <div v-if="showUpdatePopup" class="pwa-update-popup">
    <div class="pwa-update-content">
      <div class="pwa-update-message">
        <i class="fas fa-sync-alt"></i>
        <span>New version available</span>
      </div>
      <div class="pwa-update-actions">
        <button class="pwa-update-button" @click="updateApp">
          Update now
        </button>
        <button class="pwa-dismiss-button" @click="dismissPopup">
          Later
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { updateAvailable, updateServiceWorker } from '../../services/pwa.service';

export default {
  name: 'PWAUpdatePopup',
  
  setup() {
    const dismissed = ref(false);
    
    const showUpdatePopup = computed(() => 
      updateAvailable.value && !dismissed.value
    );

    const updateApp = () => {
      updateServiceWorker();
    };

    const dismissPopup = () => {
      dismissed.value = true;
      // Reset after 1 hour to show again if user hasn't updated
      setTimeout(() => {
        dismissed.value = false;
      }, 60 * 60 * 1000);
    };

    return {
      showUpdatePopup,
      updateApp,
      dismissPopup
    };
  }
}
</script>

<style scoped>
.pwa-update-popup {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  background-color: #013B82;
  color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  max-width: 300px;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.pwa-update-content {
  padding: 16px;
}

.pwa-update-message {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.pwa-update-message i {
  margin-right: 8px;
}

.pwa-update-actions {
  display: flex;
  justify-content: space-between;
}

.pwa-update-button {
  background-color: white;
  color: #013B82;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.pwa-dismiss-button {
  background: transparent;
  color: white;
  border: 1px solid white;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
}

.pwa-update-button:hover {
  background-color: #f5f5f5;
}

.pwa-dismiss-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

@media (max-width: 768px) {
  .pwa-update-popup {
    bottom: 0;
    right: 0;
    left: 0;
    max-width: 100%;
    border-radius: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
</style>